import React from 'react';

const Vip = () => {
  return (
    <div id="vip" className="container">
      <div className="content">
        <div className="mini-content">
          <h2>Get On The VIP List</h2>
          <p>Get access to special discounts, news and freebies when you sign up to our VIP List (FREE)</p>
          <div className="button-wrapper">
            <a href="" data-leadbox-popup="140e83973f72a2:10e8a98c4f46dc" data-leadbox-domain="tecniquo.lpusercontent.com" className="button">GET FREE ACCESS NOW</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Vip;



// WEBPACK FOOTER //
// ./src/components/home/Vip.js